import * as React from 'react';
import { ToastContainer, ToastContainerProps } from 'react-toastify';
import './ToastContainer.less';
import 'react-toastify/dist/ReactToastify.css';

const WrappedToastContainer = (props: ToastContainerProps) => (
	<ToastContainer
		position="top-center"
		className="toastContainer"
		toastClassName="toast"
		bodyClassName="toastBody"
		progressClassName="toastProgress"
		newestOnTop
		draggable={false}
		pauseOnHover={false}
		pauseOnFocusLoss={false}
		// eslint-disable-next-line react/jsx-props-no-spreading
		{...props}
	/>
);

export default WrappedToastContainer;
